// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-table .demo-table-error-row td{background-color:#da8247!important;color:#fff}", ""]);
// Exports
module.exports = exports;
